module.exports = __webpack_public_path__ + "img/27zlrcb8QANKHoYh4sjTKI.ac7b4f1c.svg";